import AssignTable from "./assignTable.container";

export default AssignTable;
